import DataQuery from 'data/DataQuery';
import { Fueling_FuelingSummary } from 'data/endpoints';
import { useQuery } from 'data/hooks/useQuery';
import { CommodityDetail } from 'features/contracts/enums/commodityDetail';
import NoContentWrapper from 'features/shared/components/noContentWrapper/NoContentWrapper';
import { getQueryParams } from 'features/shared/helpers/queryParams';
import { getRouteParams } from 'features/shared/helpers/routeParams';
import IAppState from 'infrastructure/store/IAppState';
import CustomerState from 'infrastructure/store/customer/CustomerState';
import React from 'react';
import { useSelector } from 'react-redux';
import { FuelingSummaryDTO } from '../dtos/FuelingSummaryDTO';
import DataGridRow from 'features/shared/components/dataGrid/DataGridRow';
import FuelingMonthSummary from '../components/FuelingMonthSummary';
import FuelingMonthSummaryHeader from '../components/FuelingMonthSummaryHeader';

type Props = {
  year: number;
  commodityDetail: CommodityDetail;
}

const FuelingSummarySection = ({ year, commodityDetail }: Props) => {

  // store
  const customer = useSelector<IAppState, CustomerState>( (store) => store.customer).customer;

  // fetch
  const summaryDurationQuery: DataQuery = {
    url: Fueling_FuelingSummary,
    params: getQueryParams("CustomerId", customer.customerId!),
    routeParams: getRouteParams("year", String(year)) 
  };
  const { data: summaries, loadStatus: summariesLoadStatus } = useQuery<FuelingSummaryDTO[]>(
    summaryDurationQuery,
    [],
    [year],
    { useTracker: true }
  );

  // sub-renders
  const renderSummaries = () => {
    return summaries.map((item) => (
      <DataGridRow key={item.month}>
        <FuelingMonthSummary 
          summary={item} 
          commodityDetail={commodityDetail}
        />
      </DataGridRow>
    ));
  };

  // render
  return (
    <NoContentWrapper
      data={summaries}
      loadStatus={summariesLoadStatus}
      noContentAsAlert
    >
      <FuelingMonthSummaryHeader 
        fuelingUnit={summaries[0]?.fuelingUnit!}
        commodityDetail={commodityDetail}
      />
      {renderSummaries()}
    </NoContentWrapper>
  )
}

export default FuelingSummarySection;